import { css } from '@emotion/react';
import { rgba, darken } from 'polished';
import { colorYiq } from '../_functions';
import Mixin from '../../../util/mixin';
import { HoverFocus } from './_hover.mixin';


export class BadgeVariant extends Mixin {
  style({$}, [bg]) {
    return css`
      color: ${colorYiq($, bg)};
      background-color: ${bg};
    `;
  }

  static atRoot($, bg) {
    return css`
      ${new HoverFocus().include($, css`
        color: ${colorYiq($, bg)};
        background-color: ${darken(0.10, bg)};
      `)}

      &:focus,
      &.focus {
        outline: 0;
        box-shadow: 0 0 0 ${$.badgeFocusWidth} ${rgba(bg, .5)};
      }
    `;
  }
}